import { ErrorBoundary } from '@genial/components';
import React from 'react';

export const SecondCopyListEmpty: React.FC = () => {
  return (
    <ErrorBoundary
      errorIconOrIllustration="NotEmptyIllustration"
      errorTitle="Não existe cobranças disponíveis"
      errorMessage="Este cliente não possui cobranças disponíveis de previdência."
    />
  );
};
